import React, { Component } from "react";
import Tooltip from "@mui/material/Tooltip";
import image1 from "./IMG_0838.jpg";
import image2 from "./img2.png";
import image3 from "./livingstories.png";
import image4 from "./monkee.PNG";
import image5 from "./smartjobs.png";
import image6 from "./livingstories.png";

export default class Porfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredItem: null,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      isMobile: false,
    };
    this.scrollContainerRef = React.createRef();
  }

  handleItemHover = (index) => {
    this.setState({ hoveredItem: index });
  };

  handleMouseDown = (e) => {
    const container = this.scrollContainerRef.current;
    this.setState({
      isDragging: true,
      startX: e.pageX - container.offsetLeft,
      scrollLeft: container.scrollLeft,
    });
  };

  handleMouseMove = (e) => {
    if (!this.state.isDragging) return;
    e.preventDefault();
    const container = this.scrollContainerRef.current;
    const x = e.pageX - container.offsetLeft;
    const walk = (x - this.state.startX) * 2;
    container.scrollLeft = this.state.scrollLeft - walk;
  };

  handleMouseUp = () => {
    this.setState({ isDragging: false });
  };

  handleMouseLeave = () => {
    this.setState({ isDragging: false });
  };

  componentDidMount() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.setupInfiniteScroll();
  }

  checkMobile = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
  };

  setupInfiniteScroll = () => {
    const container = this.scrollContainerRef.current;
    if (!container) return;

    // Clone items for seamless loop
    const originalItems = container.children.length;
    if (originalItems === 0) return;

    // Only setup infinite scroll on mobile
    if (this.state.isMobile) {
      setTimeout(() => {
        container.scrollLeft = container.scrollWidth / 3;
      }, 100);

      // Handle scroll loop
      container.addEventListener('scroll', this.handleScroll);
    }
  };

  handleScroll = () => {
    // Only loop on mobile
    if (!this.state.isMobile) return;
    
    const container = this.scrollContainerRef.current;
    if (!container || this.state.isDragging) return;

    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;
    const scrollLeft = container.scrollLeft;
    const thirdWidth = scrollWidth / 3;

    // Loop back when reaching either end
    if (scrollLeft <= 0) {
      container.scrollLeft = thirdWidth;
    } else if (scrollLeft >= thirdWidth * 2 - clientWidth) {
      container.scrollLeft = thirdWidth - (thirdWidth * 2 - clientWidth - scrollLeft);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkMobile);
    const container = this.scrollContainerRef.current;
    if (container) {
      container.removeEventListener('scroll', this.handleScroll);
    }
  }

  render() {
    let resumeData = this.props.resumeData;
    const { hoveredItem, isDragging, isMobile } = this.state;
    
    const images = [image1, image2, image5, image3, image6, image4];
    
    const backgroundStyles = {
      backgroundImage: hoveredItem !== null ? `url(${images[hoveredItem]})` : 'none',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      transition: 'background-image 0.3s ease-in-out',
      position: 'relative',
    };

    return (
      <div id="portfolio" className="pt-32 pb-32" style={backgroundStyles}>
        {/* Add overlay for better text readability */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: hoveredItem !== null ? 'rgba(0, 0, 0, 0.7)' : 'rgba(245, 245, 245, 0.95)',
          transition: 'background-color 0.3s ease-in-out',
          pointerEvents: 'none',
          zIndex: 0,
        }} />
        
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h2 className="text-5xl font-bold text-center mb-16" style={{
            color: hoveredItem !== null ? '#fff' : '#313131',
            textShadow: hoveredItem !== null ? '2px 2px 4px rgba(0,0,0,0.8)' : 'none',
            transition: 'color 0.3s ease-in-out'
          }}>
            Portfolio
          </h2>

          <div className="flex flex-wrap justify-center">
            {resumeData.portfolio &&
              resumeData.portfolio.map((item, index) => (
                <Tooltip
                  key={index}
                  title={<span style={{ fontSize: '16px' }}>Click to view project</span>}
                  followCursor
                >
                  <a
                    onMouseEnter={() => this.handleItemHover(index)}
                    onMouseLeave={() => this.handleItemHover(null)}
                    href={item.websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg mx-6 mb-12 shadow-xl hover:shadow-2xl hover:scale-105 transform transition-all duration-300"
                    style={{ width: "380px", maxWidth: "90%" }}
                  >
                    <div className="relative aspect-ratio-16/9 mb-4 rounded-t-lg overflow-hidden">
                      <iframe
                        width="100%"
                        height="240"
                        title={`Video ${index}`}
                        src={item.url}
                        frameBorder="0"
                        allowFullScreen
                      />
                    </div>

                    <div className="p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {item.name}
                      </h3>
                      <p className="text-lg text-gray-600 font-semibold mb-2">{item.subtitle}</p>
                      <p className="text-sm text-gray-500 line-clamp-3">{item.description}</p>
                    </div>
                  </a>
                </Tooltip>
              ))}
          </div>

          {/* Freelance Projects Section */}
          {resumeData.freelanceProjects && resumeData.freelanceProjects.length > 0 && (
            <div style={{ marginTop: '80px', width: '100%', padding: '0 20px' }}>
              <h3 className="text-3xl font-bold text-center mb-8" style={{
                color: hoveredItem !== null ? '#fff' : '#313131',
                textShadow: hoveredItem !== null ? '2px 2px 4px rgba(0,0,0,0.8)' : 'none',
              }}>
                Freelance Projects
              </h3>

              <div
                ref={this.scrollContainerRef}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
                onMouseUp={this.handleMouseUp}
                onMouseLeave={this.handleMouseLeave}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '20px',
                  overflowX: 'auto',
                  overflowY: 'hidden',
                  paddingBottom: '25px',
                  paddingTop: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                  scrollBehavior: 'auto',
                  cursor: isDragging ? 'grabbing' : 'grab',
                  userSelect: 'none',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  justifyContent: isMobile ? 'flex-start' : 'center',
                }}
              >
                <style>
                  {`
                    #portfolio div::-webkit-scrollbar {
                      display: none;
                    }
                  `}
                </style>
                
                {/* Render items 3 times only on mobile, once on desktop */}
                {(isMobile ? [...Array(3)] : [null]).flatMap((_, setIndex) =>
                  resumeData.freelanceProjects.map((project, index) => {
                    const uniqueKey = isMobile ? `${setIndex}-${index}` : `${index}`;
                    const cardContent = (
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h4 className="text-xl font-bold text-gray-900" style={{ marginBottom: '6px', whiteSpace: 'nowrap' }}>
                          {project.name}
                        </h4>
                        <p className="text-sm text-gray-600" style={{ margin: 0, whiteSpace: 'nowrap' }}>
                          {project.description}
                        </p>
                      </div>
                    );

                    const cardStyle = {
                      padding: '24px 28px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      minHeight: '90px',
                      gap: '20px',
                      flexShrink: 0,
                      width: 'auto',
                      whiteSpace: 'nowrap',
                    };

                    return project.url ? (
                      <a
                        key={uniqueKey}
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white rounded-lg shadow-lg hover:shadow-2xl transform hover:scale-102 transition-all duration-300"
                        style={{
                          ...cardStyle,
                          textDecoration: 'none',
                        }}
                        onDragStart={(e) => e.preventDefault()}
                      >
                        {cardContent}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#11ABB0',
                          fontWeight: '600',
                          fontSize: '13px',
                          flexShrink: 0,
                        }}>
                          <i className="fa fa-external-link" style={{ fontSize: '20px' }}></i>
                        </div>
                      </a>
                    ) : (
                      <div
                        key={uniqueKey}
                        className="bg-white rounded-lg shadow-lg transition-all duration-300"
                        style={cardStyle}
                      >
                        {cardContent}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
